const loadMore = () => {
  const DOM = {
    triggers: document.querySelectorAll('.js-load-more'),
  };

  Array.from(DOM.triggers).forEach(trigger => {
    trigger.addEventListener('click', () => {
      const container = trigger.getAttribute('data-load-container');
      const classname = trigger.getAttribute('data-load-class');
      const amount = trigger.getAttribute('data-load-amount');
      if (container) {
        const containerNode = document.querySelector(container);
        if (containerNode) {
          const posts = Array.from(
            containerNode.getElementsByClassName(classname),
          );
          posts.slice(0, amount).forEach(post => {
            post.classList.remove(classname);
          });

          if (posts.length <= amount) {
            trigger.classList.add(classname);
          }

          if (posts.length) {
            window.scrollTo(0, posts[0].offsetTop);
          }
        }
      }
    });
  });
};

export default loadMore;



// WEBPACK FOOTER //
// ./src/scripts/modules/load-more.js